var _path, _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRcmBankFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.98317 16.9146V9.2639H6.5804V16.9146H4.98317ZM10.7651 16.9146V9.2639H12.3623V16.9146H10.7651ZM1.9165 20.1091V18.5118H21.0832V20.1091H1.9165ZM16.4193 16.9146V9.2639H18.0165V16.9146H16.4193ZM1.9165 7.6667V6.1813L11.4998 0.942383L21.0832 6.1813V7.6667H1.9165Z",
    fill: "#034F81"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 17,
    r: 5,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2723_34588)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.999 16.9376C17.5768 16.9376 17.2264 16.7983 16.9479 16.5198C16.6694 16.2413 16.5301 15.8909 16.5301 15.4687C16.5301 15.0465 16.6694 14.6962 16.9479 14.4177C17.2264 14.1392 17.5768 14 17.999 14C18.4212 14 18.7719 14.1392 19.0511 14.4177C19.3303 14.6962 19.4699 15.0465 19.4699 15.4687C19.4699 15.8909 19.3303 16.2413 19.0511 16.5198C18.7719 16.7983 18.4212 16.9376 17.999 16.9376ZM15 20.0059V19.0223C15 18.787 15.0598 18.5803 15.1793 18.4021C15.2987 18.2239 15.4545 18.0884 15.6464 17.9954C16.0497 17.8083 16.4445 17.6679 16.8308 17.5741C17.2172 17.4802 17.6065 17.4333 17.9989 17.4333C18.394 17.4333 18.7837 17.4811 19.1678 17.5767C19.5519 17.6723 19.9446 17.8117 20.346 17.9947C20.5423 18.0863 20.7004 18.2212 20.8202 18.3996C20.9401 18.5779 21 18.7853 21 19.0219V20.0059H15Z",
    fill: "#034F81"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2723_34588"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    fill: "white",
    transform: "translate(15 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRcmBankFilled);
export default __webpack_public_path__ + "static/media/RCMBankFilled.eeb10213676e0cc6f73530964fa03f76.svg";
export { ForwardRef as ReactComponent };